





































































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Chart} from 'highcharts-vue';
import Loading from '@c/controls/Loading.vue';
import {getFormattedDate, getDurationStr} from '@/utils/dateTimeUtils';
import CursorDiagramToolbar from '@c/toolbar/CursorDiagramToolbar.vue';
import {CursorDiagramModeManager} from '@/logic/cursorDiagramModeManager';
import {CursorLabelModel} from '@/logic/cursors/labelModels/cursorLabelModel';
import {MarkerCursorLabelModel} from '@/logic/cursors/labelModels/markerCursorLabelModel';
import {signalDiagramModes} from '@/logic/diagramModes';
import {CursorDiagramState} from '@/logic/cursorDiagramState';
import {DiagramModeType, DiagramType, DiagramZoomType} from '@/enums/diagrams';
import diagramStoreModule from '@/store/modules/signalDiagramModule';
import {FindPeaksAction} from '@/logic/diagramActions/findPeaksAction';
import {FindPeaksLabelModel} from '@/logic/diagramActions/labelModels/findPeaksLabelModel';
import {
  ComparedDiagramData,
  DiagramData,
  DiagramMode,
  DiagramSettings,
} from '@/interfaces/diagrams';
import {DiagramAxisProvider} from '@/logic/diagramAxisProvider';
import {signalColorScheme} from '@/utils/colorSchemes';
import ToolbarToogleIconButton from '@c/toolbar/ToolbarToogleIconButton.vue';
import ToolbarIconButton from '@c/toolbar/ToolbarIconButton.vue';
import DiagramSettingsDialog from '@/components/diagrams/nodeConfigs/DiagramSettingsDialog.vue';
import SyncMenuButton from '@c/toolbar/SyncMenuButton.vue';
import {DiagramSyncModeType} from '@/components/toolbar/enums';
import {signalDiagramSyncModes} from '@c/toolbar/configurate';
import {SelectedChipsData} from '@/components/controls/interfaces';
import {reverseUnitInTitle} from '@/utils/unitUtils';
import DateTimePicker from '@c/controls/DateTimePicker.vue';
import SimpleDialog from '@c/SimpleDialog.vue';
import {SignalDiagramData, TrendOptions} from './interfaces';
import {cursorsColorScheme} from '@/utils/colorSchemes';
import {httpClient} from '@/api/baseApi';
import {DateTime} from 'luxon';
import Highcharts from 'highcharts';
import exportingInit from 'highcharts/modules/exporting';
import offlineExporting from 'highcharts/modules/offline-exporting';

exportingInit(Highcharts);
offlineExporting(Highcharts);

@Component({
  components: {
    highchart: Chart,
    CursorDiagramToolbar,
    ToolbarToogleIconButton,
    ToolbarIconButton,
    DiagramSettingsDialog,
    SimpleDialog,
    DateTimePicker,
    SyncMenuButton,
    Loading,
  },
})
export default class SignalDiagram extends Vue {
  // Показатели загрузки данных и ошибки загрузки данных
  loading = false;
  error = false;
  warn_message = '';

  //Цвет графика
  @Prop({required: true})
  color!: string;

  @Prop({required: true})
  isYLogAxis!: boolean;

  // Показатель возможности подгрузить спектр по курсору времени
  @Prop({required: false, default: false})
  isCanObtainSpectrum!: boolean;
  obtainSpectrum(ts: number | undefined | null) {
    this.$emit('obtainSpectrum', ts);
  }

  //первоначальная установка цвета графика из настроек пользователя
  @Watch('color')
  onChangedColor(newval: string, oldval: string) {
    if (newval && oldval === '') this.settings = {...this.settings, matchColor: newval};
  }

  //первоначальная установка отображения логорифм оси
  @Watch('isYLogAxis')
  onChangedLogAxis(newval: boolean) {
    if (newval !== undefined) this.settings = {...this.settings, isYLogAxis: newval};
  }

  // Настройки диаграммы
  settings: DiagramSettings = {
    isYLogAxisShow: true,
    isYLogAxis: this.isYLogAxis,
    hideZeroFrequency: false,
    type: DiagramType.Signal,
    matchColor: this.color && this.color !== '' ? this.color : signalColorScheme[0].mainColor,
  };

  // Режимы диаграммы
  diagramModes: DiagramMode[] = signalDiagramModes;

  // Диаграмма
  @Prop({required: true})
  diagram!: SignalDiagramData;
  // Список диаграмм для сравнения
  @Prop({required: false, default: null})
  comparedDiagrams!: SignalDiagramData[] | null;

  topLevelVisible = false;
  bottomLevelVisible = false;

  // Предустановленные режимы
  preselectedModes: DiagramMode[] = [
    this.diagramModes.find(mode => mode.type === DiagramModeType.View) as DiagramMode,
  ];

  // Провайдер для работы с осями
  diagramAxisProvider: DiagramAxisProvider = new DiagramAxisProvider();

  get diagramSyncModes() {
    return signalDiagramSyncModes;
  }

  // Состояние кнопки обновления графика disable or enable
  get isDisabledUpdateButton() {
    const stateDiagram = this.modeManager.getState();

    const modesNeedDisableUpdate = stateDiagram.activeModes.some(mode => {
      return [DiagramModeType.Cursor, DiagramModeType.Action].includes(mode.type);
    });

    // если мы в режиме курсора или максимумов или применен зум или выбран фиксированный интервал, то кнопка Обновлять должна быть disable
    return modesNeedDisableUpdate || this.isInZoom || this.selectedChipsData?.isCustom;
  }

  // Обновлять данные на графике
  updateDiagramIndex: number | null = 0;
  get isUpdateDiagram() {
    return this.updateDiagramIndex != null; //check both null and undefined
  }
  set isUpdateDiagram(value: boolean) {
    if (value) this.updateDiagramIndex = 0;
    else this.updateDiagramIndex = null;
  }

  get diagramStoreModule() {
    return diagramStoreModule;
  }

  // Синхронизировать
  syncButtonIndex: number | null = null;

  // Менеджер для работы с диаграммой
  modeManager: CursorDiagramModeManager = new CursorDiagramModeManager(
    DiagramType.Signal,
    new CursorLabelModel('', this.xCursorLabelFormatter),
    new MarkerCursorLabelModel('', this.xCursorLabelFormatter, this.xMarkerBandLabelFormatter),
    this.cursorApplyCallback,
    [new FindPeaksAction(new FindPeaksLabelModel('', this.xCursorLabelFormatter))],
    (() => {
      const state = new CursorDiagramState();
      state.diagramId = this.chartData.mainDiagram.id;
      state.activeModes = this.preselectedModes;
      return state;
    })(),
  );

  cursorApplyCallback() {
    if (this.cursorSyncApply) {
      diagramStoreModule.diagramSync(this.modeManager.getState());
    }
  }

  setSettings(newSettings: DiagramSettings) {
    this.settings = {...newSettings};
    this.$emit('updateUserSettings', {...newSettings});
  }

  @Prop({required: true, default: {}})
  chartData!: ComparedDiagramData;

  @Prop()
  topLevelChart!: any | null;

  @Prop()
  bottomLevelChart!: any | null;

  @Prop({default: 0, type: Number})
  xMinScaleValue!: number;

  // Значение soft min оси x, нужно для того, чтобы при отсутствии данных показывать полный период
  @Prop({type: Number})
  xSoftMin!: number;

  @Prop({type: Number})
  xSoftMax!: number;

  // Показатель того, что применен зум
  @Prop({required: false, type: Boolean, default: false})
  isInZoom!: boolean;

  @Watch('isInZoom')
  onChangeIsInZoom(value: any) {
    if (!value) this.modeManager.clearZoom();
  }

  @Prop({required: true})
  selectedChipsData!: SelectedChipsData;

  // если выбран чипс с фиксированным интервалом, то выключаем обновление
  @Watch('selectedChipsData', {immediate: true})
  onChangeSelectedChipsData(value: SelectedChipsData) {
    this.modeManager.setSelectedChipsData(value);
    const stateDiagram = this.modeManager.getState();

    // TODO: неправильно менять в скопированном состоянии!
    if (value.isCustom) stateDiagram.isUpdateDiagram = false;

    if (this.intervalsSyncApply) diagramStoreModule.diagramSync(stateDiagram);
  }

  //Ключ для обновления размеров диаграммы
  @Prop({required: false, type: Number, default: 0})
  resizedKey!: number;

  @Watch('resizedKey')
  onResizedKeyChanged() {
    this.getChart().reflow();
  }

  // Идентификатор основной серии графика
  mainSeriesId = `mainSeries`;

  // Список идентификаторов графиков на диаграмме (нужно знать для подключения курсоров)
  chartSeriesIds: string[] = [];

  //Внешний тренд
  @Prop({required: false})
  trend!: TrendOptions | null;

  //Настройки линий трендов
  o_trend: TrendOptions[] = [new TrendOptions()];

  // Показатель активности тулбара для работы с графиком
  get toolbarDisabled() {
    return !this.chartData.mainDiagram.data.length;
  }

  mounted() {
    const chart = this.getChart();
    this.modeManager.init(chart, this.chartSeriesIds, this.xMinScaleValue);
  }

  /*
    Действия при изменении статуса отображения линии курсора
  */
  changeShowCursorLine(show: boolean) {
    //Проводим изменения для текущего графика
    this.modeManager.showLine(show);
    //Если в режиме синхронизации, то отправляем другим графикам
    if (this.cursorSyncApply) diagramStoreModule.diagramSync(this.modeManager.getState());
  }

  /*
    Действия при изменении статуса отображения отметок курсора
  */
  changeShowCursorTooltips(show: boolean) {
    this.modeManager.showTooltips(show);
    if (this.cursorSyncApply) diagramStoreModule.diagramSync(this.modeManager.getState());
  }

  /*
    обновить стейт, отвечающий за "живое" обновление графиков
  */
  onUpdateButtonClick() {
    this.modeManager.updateDiagram(this.isUpdateDiagram);
    const stateDiagram = this.modeManager.getState();
    if (this.syncApply) diagramStoreModule.diagramSync(stateDiagram);
    const currentLiveUpdateStatus = this.modeManager.canLiveUpdate();
    this.$emit('liveUpdateStatusChanged', currentLiveUpdateStatus);
  }

  /*
    Выбор режима графика
  */
  selectModes(modes: DiagramMode[]) {
    const previousLiveUpdateStatus = this.modeManager.canLiveUpdate();
    this.modeManager.updateState([...modes]);
    if (this.syncApply) {
      diagramStoreModule.diagramSync(this.modeManager.getState());
    }
    //Если между предыдущим и новым состоянием произошли изменения в статусе обновления, то
    //отправляем нотификацию
    if (!this.isInZoom) this.liveUpdateStatusChangedNotify(previousLiveUpdateStatus);
  }

  /*
    Отправить уведомление об изменении состояния "живого" обновления
  */
  liveUpdateStatusChangedNotify(previousLiveUpdateStatus: boolean) {
    const newLiveUpdateStatus = this.modeManager.canLiveUpdate();
    if (previousLiveUpdateStatus !== newLiveUpdateStatus) {
      this.$emit('liveUpdateStatusChanged', newLiveUpdateStatus);
    }
  }

  /*
    Показатель применения синхронизации к графику
  */
  get syncApply() {
    return this.cursorSyncApply || this.zoomXSyncApply || this.intervalsSyncApply;
  }

  get cursorSyncApply() {
    return (
      this.chartData &&
      diagramStoreModule.syncModes.some(x => x.type === DiagramSyncModeType.Cursors) &&
      diagramStoreModule.syncDiagrams.some(x => x.id === this.chartData.mainDiagram.id)
    );
  }

  get zoomXSyncApply() {
    return (
      this.chartData &&
      diagramStoreModule.syncModes.some(x => x.type === DiagramSyncModeType.ZoomX) &&
      diagramStoreModule.syncDiagrams.some(x => x.id === this.chartData.mainDiagram.id)
    );
  }

  get intervalsSyncApply() {
    return (
      this.chartData &&
      diagramStoreModule.syncModes.some(x => x.type === DiagramSyncModeType.TimeIntervals) &&
      diagramStoreModule.syncDiagrams.some(x => x.id === this.chartData.mainDiagram.id)
    );
  }

  @Watch('modeManager.changedZoomXKey')
  onChangeZoomXKey() {
    if (this.zoomXSyncApply) diagramStoreModule.diagramSync(this.modeManager.getState());
  }

  /*
    Computed поле, привязанное к vuex и watcher для него
  */
  get sync() {
    return diagramStoreModule.sync;
  }
  @Watch('sync')
  syncChanged(sync: {syncModes: any[]; syncDiagrams: any[]; syncedState: CursorDiagramState}) {
    if (!sync.syncDiagrams.some(x => x.id === this.chartData.mainDiagram.id)) return;

    //Применять только к другим графикам
    if (
      this.sync.syncModes.some(x => x.type === DiagramSyncModeType.ZoomX) &&
      this.modeManager.zoomType !== DiagramZoomType.X &&
      this.modeManager.zoomType !== DiagramZoomType.None
    ) {
      this.modeManager.zoomType = DiagramZoomType.X;
      this.skipZoom(false);
    }

    const value: CursorDiagramState = sync.syncedState;

    //проверка на то, что это не данная диаграмма
    //TODO: вынести наверх
    if (value && value.diagramId === this.chartData.mainDiagram.id) {
      return;
    }

    const previousLiveUpdateStatus = this.modeManager.canLiveUpdate();
    const toolbar = this.getToolbar();

    // не нужно синхронизировать если уже синхронизировано
    let changes = false;
    if (value && sync.syncModes.some(x => x.type === DiagramSyncModeType.TimeIntervals)) {
      const state = new CursorDiagramState(value);
      state.diagramId = this.chartData.mainDiagram.id;
      this.modeManager.patchIntervalState(state);
      changes = true;
      this.$emit('syncChips', value.selectedChipsData);
    }

    if (value && sync.syncModes.some(x => x.type === DiagramSyncModeType.Cursors)) {
      //TODO: Тут обновляем только курсоры
      const state = new CursorDiagramState(value);
      state.diagramId = this.chartData.mainDiagram.id;
      this.modeManager.patchCursorState(state, true);
      changes = true;
      this.modeManager.showLine(state.isShowLine);
      this.modeManager.showTooltips(state.isShowTooltips);
      this.modeManager.updateDiagram(state.isUpdateDiagram);
    }

    //вызов patchCursorState должен выполняться до patchZoomState из-за того, что
    //при установке курсора сбрасывается зум
    if (value && sync.syncModes.some(x => x.type === DiagramSyncModeType.ZoomX)) {
      const state = new CursorDiagramState(value);
      state.diagramId = this.chartData.mainDiagram.id;
      changes = true;
      this.modeManager.patchZoomState(state, true);
      if (!value.selectedZoomXData?.active) {
        this.skipZoom(false);
      } else this.$emit('zoom', value.selectedZoomXData.interval);
    }

    if (changes) {
      const syncedState = this.modeManager.getState();
      toolbar.setupState(syncedState);
      if (!value.selectedZoomXData?.active)
        this.liveUpdateStatusChangedNotify(previousLiveUpdateStatus);
    }
  }

  xFormatter(e: any) {
    return getFormattedDate(e.value, 'HH:mm:ss<br />(dd.MM.yyyy)');
  }

  xCursorLabelFormatter(value: any) {
    return getFormattedDate(value, 'HH:mm:ss (dd.MM)');
  }

  xMarkerBandLabelFormatter(value: any) {
    return getDurationStr(value);
  }

  get getOptions() {
    const series = [];
    const that = this;

    // Выключаем границы по умолчанию
    if (this.topLevelChart) {
      series.push({
        id: 'topLevel',
        name: 'Верхняя граница',
        data: this.topLevelChart,
        visible: this.topLevelVisible,
        type: 'line',
        color: 'red',
        dashStyle: 'longdash',
      });
    }
    if (this.bottomLevelChart) {
      series.push({
        id: 'bottomLevel',
        name: 'Нижняя граница',
        data: this.bottomLevelChart,
        visible: this.bottomLevelVisible,
        type: 'line',
        color: 'blue',
        dashStyle: 'longdash',
      });
    }

    this.mainSeriesId = this.chartData.mainDiagram.id;
    this.chartSeriesIds = [this.mainSeriesId];
    const warn_ts = [Infinity, Infinity, Infinity];
    this.warn_message = '';
    const millis = Date.now();

    series.push({
      name: this.chartData.mainDiagram.name,
      id: this.chartData.mainDiagram.id,
      data: this.chartData.mainDiagram.data,
      type: 'line',
      color: this.settings.matchColor,
      findNearestPointBy: 'xy',
      yAxis: 0,
      zIndex: this.chartData.comparedDiagrams ? this.chartData.comparedDiagrams.length : 0,
    });
    if (this.trend?.data) {
      series.push({
        id: 'trend_data',
        name: 'Данные тренда',
        data: this.trend.data,
        type: 'line',
        color: cursorsColorScheme[1],
        dashStyle: 'dash',
      });
      series.push({
        id: 'trend_poly',
        name: 'Полином тренда',
        data: this.poly(
          this.trend.data[0][0],
          this.trend.data[this.trend.data.length - 1][0],
          50,
          this.trend.factors,
        ),
        type: 'line',
        color: cursorsColorScheme[2],
        dashStyle: 'dashdot',
      });
    }
    if (this.o_trend[0].data) {
      series.push({
        id: 'trend0',
        name: `Тренд (${this.chartData.mainDiagram.name})`,
        data: this.poly(this.xSoftMin, this.xSoftMax, 50, this.o_trend[0].data),
        type: 'line',
        color: this.settings.matchColor,
        dashStyle: 'longdash',
      });
      if (this.o_trend[0].warn_ts != null && this.o_trend[0].warn_ts.length >= 3) {
        if (this.o_trend[0].warn_ts[0] > millis && this.o_trend[0].warn_ts[0] < warn_ts[0])
          warn_ts[0] = this.o_trend[0].warn_ts[0];
        if (this.o_trend[0].warn_ts[1] > millis && this.o_trend[0].warn_ts[1] < warn_ts[1])
          warn_ts[1] = this.o_trend[0].warn_ts[1];
        if (this.o_trend[0].warn_ts[2] > millis && this.o_trend[0].warn_ts[2] < warn_ts[2])
          warn_ts[2] = this.o_trend[0].warn_ts[2];
      }
    }

    const yAxisData = this.diagramAxisProvider.getYAxis(
      this.chartData,
      signalColorScheme,
      this.settings.isYLogAxis,
    );
    const yAxis = yAxisData.axis;

    this.chartData.comparedDiagrams.forEach((d: DiagramData, index: number) => {
      const comparedSeriesId = d.id;
      series.push({
        name: d.name,
        id: comparedSeriesId,
        data: d.data,
        type: 'line',
        color: yAxisData.comparedSeriesColors[index],
        yAxis: yAxisData.comparedSeriesAxisNumbers[index],
        zIndex: index,
      });
      if (this.o_trend.length > 1 && this.o_trend[index + 1].data) {
        series.push({
          id: `trend${index + 1}`,
          name: `Тренд (${d.name})`,
          data: this.poly(this.xSoftMin, this.xSoftMax, 50, this.o_trend[index + 1].data),
          type: 'line',
          color: yAxisData.comparedSeriesColors[index],
          dashStyle: 'longdash',
        });
        if (
          this.o_trend[index + 1].warn_ts != null &&
          this.o_trend[index + 1].warn_ts.length >= 3
        ) {
          if (
            this.o_trend[index + 1].warn_ts[0] > millis &&
            this.o_trend[index + 1].warn_ts[0] < warn_ts[0]
          )
            warn_ts[0] = this.o_trend[index + 1].warn_ts[0];
          if (
            this.o_trend[index + 1].warn_ts[1] > millis &&
            this.o_trend[index + 1].warn_ts[1] < warn_ts[1]
          )
            warn_ts[1] = this.o_trend[index + 1].warn_ts[1];
          if (
            this.o_trend[index + 1].warn_ts[2] > millis &&
            this.o_trend[index + 1].warn_ts[2] < warn_ts[2]
          )
            warn_ts[2] = this.o_trend[index + 1].warn_ts[2];
        }
      }
      this.chartSeriesIds.push(comparedSeriesId);
    });
    if (warn_ts[2] > 0) {
      if (warn_ts[2] - millis > 0 && warn_ts[2] - millis < 2592000000) {
        this.warn_message =
          'Порог ошибки будет превышен ' +
          new Date(warn_ts[2]).toISOString().substring(0, 10) +
          '! Выполните диагностику узла!';
      }
    }
    if (warn_ts[1] > 0) {
      if (warn_ts[1] - millis > 0 && warn_ts[1] - millis < 2592000000) {
        this.warn_message =
          'Порог опасности будет превышен ' +
          new Date(warn_ts[1]).toISOString().substring(0, 10) +
          '. Выполните диагностику узла.';
      }
    }
    if (warn_ts[0] > 0) {
      if (warn_ts[0] - millis > 0 && warn_ts[0] - millis < 2592000000) {
        this.warn_message =
          'Порог предупреждения будет превышен ' +
          new Date(warn_ts[0]).toISOString().substring(0, 10) +
          '. Требуется выполнить диагностику узла.';
      }
    }

    return {
      credits: {
        enabled: false,
      },
      title: '',
      xAxis: {
        gridLineWidth: 1,
        title: {
          text: 'Время',
        },
        labels: {
          formatter: this.xFormatter,
        },
        softMin: this.xSoftMin,
        softMax: this.xSoftMax,
      },
      yAxis: yAxis,
      //графики
      series,
      navigation: {
        buttonOptions: {
          enabled: false,
        },
      },
      plotOptions: {
        series: {
          states: {
            //отключает выделение точки на графике
            hover: {
              enabled: false,
              halo: {
                size: 0,
              },
              inactive: {
                enabled: false,
              },
            },
          },
          events: {
            //   legendItemClick: function(e: any) {
            //     e.preventDefault();
            //   },
            hide: function(e: any) {
              that.showOrHide(e);
            },
            show: function(e: any) {
              that.showOrHide(e);
            },
          },
        },
        line: {
          turboThreshold: 0,
          boostThreshold: 0,
          marker: {
            enabled: false,
            radius: 0,
          },
          states: {
            inactive: {
              opacity: 1,
            },
          },
        },
      },
      chart: {
        //animation: false, //общая анимация включена - расскоментировать, чтобы отключить
        events: {
          selection: this.onSelection,
          render: this.onRender,
          afterUpdate: this.afterUpdate,
        },
        zoomType: this.modeManager.zoomType,
      },
      legend: {
        useHTML: true,
        align: 'left',
        verticalAlign: 'bottom',
        borderWidth: 0,
        enabled: true,
      },
      tooltip: {
        enabled: false,
        crosshairs: [false], //отключает линию по умолчанию
      },
    };
  }

  showOrHide(e: any) {
    if (e.target.index == 0) this.topLevelVisible = e.target.visible;
    if (e.target.index == 1) this.bottomLevelVisible = e.target.visible;
    const stateDiagram = this.modeManager.getState();
    const modes = stateDiagram.activeModes;
    this.modeManager.updateState([...modes]);
  }

  /*
    Действия после обновления графика - необходимо перерисовать
    все, что применено на график с режимов
    т. к. объект графика обновится
  */
  afterUpdate() {
    const state = this.modeManager.getState();

    if (this.sync && diagramStoreModule.syncedState) {
      const syncedState = new CursorDiagramState({
        ...diagramStoreModule.syncedState,
        actionData: state.actionData,
      });
      this.modeManager.updateActiveModes(syncedState, this.chartSeriesIds);
    } else this.modeManager.updateActiveModes(state, this.chartSeriesIds);
  }

  onSelection(e: any) {
    e.preventDefault();
    const dateInterval = this.modeManager.applyZoom(e.xAxis[0], e.yAxis[0]);
    if (dateInterval) this.$emit('zoom', dateInterval);
  }

  onRender() {
    // Некоторые действия, например отрисовку отметок на диагамме нужно делать на onRender
    // т. к. требуется перерисовка на любое изменение графика (например изменение размера)
    this.modeManager.renderActiveModes();

    const chart = this.getChart();
    if (chart && chart.resetZoomButton) {
      chart.resetZoomButton.hide();
    }
  }

  //Сброс зума
  skipZoom(updateState = true) {
    const res = this.modeManager.skipZoom(updateState);
    if (res) this.$emit('skipZoom');
  }

  //Отмена текущего зума
  undoZoom() {
    const result = this.modeManager.undoZoom();
    if (result === 'skip') this.$emit('skipZoom');
    else if (result) this.$emit('zoom', result);
  }

  getChart() {
    return (this.$refs.chart as any).chart;
  }

  getToolbar() {
    return this.$refs.cursorDiagramToolbar as any;
  }

  //Сохранение картинки с графиком
  downloadChart() {
    const chart = this.getChart();
    const yAxisTitles = chart.yAxis.map((a: any) => ({
      title: {
        text: reverseUnitInTitle(a.options.title.text),
        style: {color: a.options.title.style.color},
      },
      opposite: a.opposite,
      tickPositions: a.tickPositions,
      labels: {style: {color: a.options.labels.style.color}},
    }));
    chart.exportChartLocal(
      {
        type: 'image/png',
        sourceWidth: 960,
        sourceHeight: 540,
        fallbackToExportServer: false,
      },
      {
        title:
          this.chartData.comparedDiagrams.length > 0
            ? false
            : {text: reverseUnitInTitle(this.chartData.mainDiagram.name)},
        yAxis: yAxisTitles,
      },
    );
  }

  trendDialog = false;
  formValid = false;

  poly(x0: number, x1: number, num: number, coeff: number[]) {
    const dx = (x1 - x0) / num;
    const data = [];
    for (let i = 0; i < num + 0.25 * num; i++) {
      const x = x0 + i * dx;
      const y = coeff[0] + coeff[1] * x + coeff[2] * x * x + coeff[3] * x * x * x;
      data.push({x: x0 + i * dx, y: y});
    }
    return data;
  }

  async trendSettingsChanged() {
    this.loading = true;
    this.error = false;
    try {
      for (let index = 0; index < this.o_trend.length; index++) {
        if (!this.o_trend[index].enabled) {
          this.o_trend[index].data = null;
          continue;
        }
        const diagram: SignalDiagramData | undefined | null =
          index == 0
            ? this?.diagram
            : this?.comparedDiagrams === null
            ? null
            : this?.comparedDiagrams[index - 1];
        const params: any = {
          event_name: diagram?.measurement.eventType,
          field_name: diagram?.measurement.alias,
          start_date: this.o_trend[index].startTsFlag ? this.xSoftMin : this.o_trend[index].startTs,
          interval: this.o_trend[index].interval,
          mode: this.o_trend[index].metric,
          inverse_data: false,
          is_monotone: !!this.o_trend[index].monotonityFlag,
          min_border_value: this.o_trend[index].threshold,
        };
        const {data} = await httpClient.get(`/modules/events/${this.diagram.moduleGUID}/trend`, {
          params,
        });
        this.o_trend[index].data = data[1].reverse();
        this.o_trend[index].warn_ts = data.length > 2 ? data[2] : null;
      }
    } catch (e) {
      console.log(e);
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  openTrendDialog() {
    this.chartData.comparedDiagrams.forEach((d: DiagramData, index: number) => {
      if (this.o_trend.length <= index + 1) this.o_trend.push(new TrendOptions());
    });
    this.trendDialog = true;
  }

  setStartTs(index: number) {
    const dtp: DateTimePicker[] = this?.$refs?.dtp as DateTimePicker[];
    let date =
      dtp[index].dataPickerValue === null
        ? 0
        : DateTime.fromISO(dtp[index].dataPickerValue).toMillis();
    if (date && dtp[index].timeValue) date = dtp[index].setTime(date, dtp[index].timeValue);
    this.o_trend[index].startTs = date;
  }
}
